import axios from './axios-config';

export const normalizeRows = (response) => {
  const rows = response?.data?.data?.data;
  return Array.isArray(rows) ? rows : [];
};

export const fetchAiCoachConversations = () =>
  axios.get('/warboard/ai-coach/conversations', { withCredentials: true });

export const fetchAiCoachMessages = (conversationId) => {
  if (!conversationId) {
    return Promise.reject(new Error('conversationId is required'));
  }
  return axios.get(
    `/warboard/ai-coach/conversations/${encodeURIComponent(conversationId)}/messages`,
    { withCredentials: true }
  );
};
